import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import Loader from "../components/custom/Loader";
import { useAuthUser } from "../hooks/useAuthUser";

const EmailVerifiedProtectedRoutes = () => {
  const token = useSelector((state) => state.auth.token);
  const { user } = useAuthUser();

  if (!token || !user) {
    return <Loader />;
  }
  if (!user?.email_verified_at) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Outlet />;
};

export default EmailVerifiedProtectedRoutes;
